import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Jumbotron, Row } from "react-bootstrap"
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri"
import { withTranslation } from 'react-i18next';
import ReactPaginate from "react-paginate"
import { useParams } from 'react-router'

import Get from '../../api/Get'
import { DOCTOR_APPOINTMENT_BY_PATIENT,
    DOCTORS_BY_ID,
    MY_APPOINTMENT,
    APPOINTMENT_PATIENT
} from '../../api/Routes'
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import { isCitasProximas } from "../../utils/isCitasProximas"
import CardCitasCliente from '../../components/CardCitasCliente'
import CancelCitaModal from './modals/CancelCitaModal'
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';
import useCompanyType from '../../hook/useCompanyType';

const CitasPaciente = ({t}) => {
    const {idDoctor, idPaciente}= useParams()
    const [loading, setLoading] = useState(false)
    const [doctor, setDoctor] = useState()
    const [proximasCitas, setProximasCitas] = useState([])
    const [previasCitas, setPreviasCitas] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagePC, setCurrentPagePC] = useState(1)
    const [pageCount, setPageCount] = useState(0)
    const [currentPagePageCount, setCurrentPagePageCount] = useState(0)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [citaToCancel, setCitaToCancel] = useState()
    const [loadData, setLoadData] = useState(true)

    const postsPerPage = 12;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const PCLastPost = currentPagePC * postsPerPage
    const PCFirstPost= PCLastPost - postsPerPage

    //Token de autentificaciÃ³n para los servicios
    const {auth} = useContext(authContext)
    const companyType = useCompanyType()

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Get informaciÃ³n del doctor
    useEffect(() => {
        let mounted = true
        const url = `${DOCTORS_BY_ID}/${idDoctor}`
        setLoading(true)
        Get({url: url, access_token: auth.data.access_token})
        .then((resp) => {
            if(mounted){
                setDoctor(resp.data.data)
            }
            setLoading(false)
        }).catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
        return () => mounted = false;
    }, [])

    //Get informaciÃ³n de las citas
    useEffect(() => {
        let mounted = true

        // For Colombia: get all patient appointments, for Mexico: get doctor-patient appointments
        const url = companyType === "colombia" 
            ? `${APPOINTMENT_PATIENT}/${idPaciente}`
            : `${DOCTOR_APPOINTMENT_BY_PATIENT}/${idDoctor}/${idPaciente}`
        setLoading(true)

        Get({url: url, access_token: auth.data.access_token})
        .then((resp) => {
            if(mounted){
                const data = resp.data.data.response
                let proximasCitas = data.filter(item=>isCitasProximas(item.scheduleDTO.dateTimeInit)).reverse()
                let citasPrevias = data.filter(item=>!isCitasProximas(item.scheduleDTO.dateTimeInit))

                setProximasCitas(proximasCitas)
                setPreviasCitas(citasPrevias)

                if(data.length > 0){
                    let pC = Math.ceil(citasPrevias.length / postsPerPage)
                    setPageCount(pC)

                    let pageCounter = Math.ceil(proximasCitas.length / postsPerPage)
                    setCurrentPagePageCount(pageCounter)
                }
            }
            setLoading(false)
        }).catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
        return () => mounted = false;
     }, [loadData, companyType, idDoctor, idPaciente, auth.data.access_token])


    const handlePageClick = (data) => setCurrentPage(data.selected + 1)
    const handlePageProximaCitaClick = (data) => setCurrentPagePC(data.selected + 1)
    const handleShowModalCalcel = (item) => {
        setCitaToCancel(item)
        setShowCancelModal(true)
    }
    const handleCloseModalCalcel = () => setShowCancelModal(false)

    return (<>
        {loading && <LoadingList />}

        <CancelCitaModal show={ showCancelModal } 
            handleHideModal={ handleCloseModalCalcel } 
            item={ citaToCancel } 
            setLoading={ setLoading }
            setLoadData={ setLoadData }
            setShowModalServer={setShowModalError}
            setErrorServer={setErrorServer}
        />

        <div className='body'>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top-2">{t('mis_citas')}</h2>
                    {doctor && <label className="font-weight-bold text-secondary">{`${doctor?.name} ${doctor?.lastName}`}</label>}
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="12"><h2 className="color-646D82">{t('proximas')}</h2></Col>
                <Col xs="12" md="12">
                    {
                        (proximasCitas.length === 0) ? <Row className="mt-5">
                            <Col>
                                <Jumbotron>
                                    <Container>
                                        <p className="text-center">{t('no_hay_citas')}</p>
                                    </Container>
                                </Jumbotron>
                            </Col>
                        </Row> : <Row>
                            {
                                proximasCitas.slice(PCFirstPost, PCLastPost).map((item, i)=>(
                                    <Col xs="12" md="4" key={i}>
                                        <CardCitasCliente item={item} showModal={handleShowModalCalcel} auth={auth}/>
                                    </Col>
                                ))
                            }
                        </Row>
                    }
                    {
                        proximasCitas.length > 0 && <Row className="mt-5">
                            <Col>
                                <ReactPaginate
                                    previousLabel={ <RiArrowLeftSLine /> }
                                    nextLabel={ <RiArrowRightSLine /> }
                                    breakLabel={ '...' }
                                    breakClassName={ 'break-me' }
                                    pageCount={ currentPagePageCount }
                                    marginPagesDisplayed={ 2 }
                                    pageRangeDisplayed={ 3 }
                                    onPageChange={ handlePageProximaCitaClick }
                                    containerClassName={ 'pagination' }
                                    subContainerClassName={ 'pages pagination' }
                                    activeClassName={ 'active' }
                                />
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="12"><h2 className="color-646D82">{t('anteriores')}</h2></Col>
                <Col xs="12" md="12">
                    {
                        (previasCitas.length === 0) ? <Row className="mt-5">
                            <Col>
                                <Jumbotron>
                                    <Container>
                                        <p className="text-center">{t('no_hay_citas')}</p>
                                    </Container>
                                </Jumbotron>
                            </Col>
                        </Row> : <Row>
                            {
                                previasCitas.slice(indexOfFirstPost, indexOfLastPost).map((item, i)=>(
                                    <Col xs="12" md="4" key={i}>
                                        <CardCitasCliente item={item} 
                                            showModal={handleShowModalCalcel} 
                                            showDelete={ false } 
                                            showEdit={ false } 
                                            auth={auth}
                                            currentDoctorId={idDoctor}
                                            companyType={companyType}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    }
                    
                    {
                        previasCitas.length > 0 && <Row className="mt-5">
                            <Col>
                                <ReactPaginate
                                    previousLabel={<RiArrowLeftSLine />}
                                    nextLabel={<RiArrowRightSLine />}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default withTranslation()(CitasPaciente)